import { Grid, Button } from '@mui/material';
import { unwrapResult } from '@reduxjs/toolkit';
import InfoPopup from 'components/InfoPopup';
import { useUploadModuleLicense } from 'features/systemModules/api/uploadModuleLicense';
import { queryClient } from 'lib/react-query';
import React from 'react';
import { ChangeEvent, useState } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { createLicense } from '../analyzers/analyzerSlice';

const LicenseUploader = () => {
  const dispatch = useAppDispatch();
  const uploadSystemLicense = useUploadModuleLicense({});
  const [snackbar, setSnackBar] = useState<{
    severity: 'success' | 'error';
    open: boolean;
    message: string;
  }>({
    severity: 'success',
    open: false,
    message: '',
  });

  const handleClose = () => {
    setSnackBar({
      ...snackbar,
      open: false,
    });
  };

  const handleUploadLicense = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target?.result;
      if (!text || typeof text !== 'string') return;
      const textObj = JSON.parse(text);
      try {
        //System module license
        if (textObj.hasOwnProperty('iv')) {
          await uploadSystemLicense.mutateAsync(textObj);
        } else {
          const resultAction = await dispatch(createLicense(textObj));
          unwrapResult(resultAction);
        }
        setSnackBar({
          open: true,
          severity: 'success',
          message: 'License uploaded successfully!',
        });
        queryClient.invalidateQueries(['analyzers']);
        queryClient.invalidateQueries(['switches']);
      } catch (e) {
        setSnackBar({
          open: true,
          severity: 'error',
          message: 'License upload failed!',
        });
      }
    };
    reader.readAsText(file);
  };
  return (
    <Grid item>
      <input
        style={{ display: 'none' }}
        id='contained-button-file'
        type='file'
        accept='.lic'
        onChange={handleUploadLicense}
      />
      <label htmlFor='contained-button-file'>
        <Button variant='contained' color='primary' component='span'>
          Upload Module License
        </Button>
      </label>
      <InfoPopup
        openCondition={snackbar.open}
        error={snackbar.severity === 'error'}
        success={snackbar.severity === 'success'}
        message={snackbar.message}
        title={null}
        handleClose={handleClose}
      />
    </Grid>
  );
};

export default LicenseUploader;
